import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../../theme/hooks/useAlerts'
import { queryKey as bijlagenAssignedQueryKey } from '../../bijlagen/hooks/useAssignedBijlagenForEntity'
import { queryKey as bijlagenQueryKey } from '../../bijlagen/hooks/useBijlagenForEntity'
import { updateSubprocesForEntity } from '../services/updateSubprocesForEntity'

import { queryKey as subProcessenQueryKey } from './useSubprocessenForEntity'

export { useUpdateSubprocesForEntity }

const useUpdateSubprocesForEntity = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: updateSubprocesForEntity,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [subProcessenQueryKey] })
      queryClient.invalidateQueries({ queryKey: [bijlagenAssignedQueryKey] })
      queryClient.invalidateQueries({ queryKey: [bijlagenQueryKey] })

      successAlert('Succesvol aangepast')
    },
  })
}
